import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar bg-base-100">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li className="font-bold">
              <Link to="/">Home</Link>
            </li>

            <li className="font-bold">
              <a href="#about">About Me</a>
            </li>

            <li className="font-bold">
              <a href="#skills">Skills</a>
            </li>
            <li className="font-bold">
              <a href="#projects">Projects</a>
            </li>

            <li className="font-bold">
              <a href="#contacts">Contacts</a>
            </li>
            <li className="font-bold">
              <Link to="/blogs">Blogs</Link>
            </li>
            <li className="font-bold">
              <a
                className="btn btn-sm btn-secondary font-bold"
                href="https://drive.google.com/file/d/1MKgXhAKbV9TJJ59J1x4Vk75ZW2sMX_hV/view"
                target="_blank"
              >
                Resume
              </a>
            </li>
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost normal-case text-lg md:text-3xl">
          Shahinul Islam
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li className="font-bold">
            <Link to="/">Home</Link>
          </li>
          <li className="font-bold">
            <a href="#about">About Me</a>
          </li>

          <li className="font-bold">
            <a href="#skills">Skills</a>
          </li>
          <li className="font-bold">
            <a href="#projects">Projects</a>
          </li>

          <li className="font-bold">
            <a href="#contacts">Contacts</a>
          </li>
          <li className="font-bold">
            <Link to="/blogs">Blogs</Link>
          </li>
        </ul>
      </div>
      {/* <div className="navbar-end">
        <a
          className="btn btn-sm btn-secondary font-bold"
          href="https://drive.google.com/file/d/1MKgXhAKbV9TJJ59J1x4Vk75ZW2sMX_hV/view"
          target="_blank"
        >
          Resume
        </a>
      </div> */}
    </div>
  );
};

export default Navbar;
